import { ChangeDetectorRef, DestroyRef, inject } from '@angular/core';

import { BetslipConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';
import { EpcotConfigService, EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';

export abstract class BaseBetBuilderComponent {
    isEpcotEnabled: boolean;
    isComboType: boolean;
    isBetbuilderComboEnabled: boolean;
    protected readonly destroyRef = inject(DestroyRef);

    constructor(
        private interpolationPipe: StringInterpolationPipe,
        private sitecore: Sitecore,
        private epcotConfigService: EpcotConfigService,
        private change: ChangeDetectorRef,
        private betslipConfig: BetslipConfig,
    ) {
        this.isEpcotEnabled = this.epcotConfigService.isEnabled(EpcotModule.Betslip);
        this.isBetbuilderComboEnabled = this.betslipConfig.allowBetbuilderCombos;
    }

    get isCombo(): boolean {
        return this.isEpcotEnabled && this.isComboType && this.isBetbuilderComboEnabled;
    }

    setIsCombo(combo: boolean) {
        this.isComboType = combo;
        this.change.markForCheck();
    }

    get headerText(): string {
        if (this.isEpcotEnabled && this.sitecore.betBuilderEntainUI.messages) {
            return this.interpolationPipe.transform(this.sitecore.betBuilderEntainUI.messages.BuildABetLegsCount, {
                legsCount: this.selectionsLength,
            });
        }

        return this.sitecore.globalMessages.BetBuilderBadgeText;
    }

    get checkboxThemeOn(): string {
        return this.isEpcotEnabled ? 'theme-checkbox-on-i' : 'theme-checkbox-on';
    }

    abstract get selectionsLength(): number;
}
